import { render } from "./StockItemTop.vue?vue&type=template&id=27cde33b&scoped=true&ts=true"
import script from "./StockItemTop.vue?vue&type=script&lang=ts"
export * from "./StockItemTop.vue?vue&type=script&lang=ts"

import "./StockItemTop.vue?vue&type=style&index=0&id=27cde33b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cde33b"]])

export default __exports__